const ordersActionTypes = {
  FETCH_ALL_ORDERS: 'FETCH_ALL_ORDERS',
  FETCH_ALL_ORDERS_SUCCESS: 'FETCH_ALL_ORDERS_SUCCESS',
  FETCH_ALL_ORDERS_FAIL: 'FETCH_ALL_ORDERS_FAIL',
  SET_ALL_ORDERS_ASSIGNED_ENTITY_DETAILS: 'SET_ALL_ORDERS_ASSIGNED_ENTITY_DETAILS',

  FETCH_ORDER_DETAILS: 'FETCH_ORDER_DETAILS',
  FETCH_ORDER_DETAILS_SUCCESS: 'FETCH_ORDER_DETAILS_SUCCESS',
  FETCH_ORDER_DETAILS_FAIL: 'FETCH_ORDER_DETAILS_FAIL',

  SET_ORDER_PATIENT_USER_DETAILS: 'SET_ORDER_PATIENT_USER_DETAILS',
  SET_ORDER_ASSIGNED_ENTITY_DETAILS: 'SET_ORDER_ASSIGNED_ENTITY_DETAILS',
  SET_ORDER_LOGS_DETAILS: 'SET_ORDER_LOGS_DETAILS',
  SET_ORDER_SERVICES_DETAILS: 'SET_ORDER_SERVICES_DETAILS',
  SET_ORDER_RESULTS: 'SET_ORDER_RESULTS',

  SET_ORDER_DISPENSED_ITEMS_DETAILS: 'SET_ORDER_DISPENSED_ITEMS_DETAILS',

  FETCH_ASSIGN_ORDER_TO_ENTITY: 'FETCH_ASSIGN_ORDER_TO_ENTITY',
  FETCH_ASSIGN_ORDER_TO_ENTITY_SUCCESS: 'FETCH_ASSIGN_ORDER_TO_ENTITY_SUCCESS',
  FETCH_ASSIGN_ORDER_TO_ENTITY_FAIL: 'FETCH_ASSIGN_ORDER_TO_ENTITY_FAIL',

  FETCH_ORDER_SERVICES_SUGGESTIONS: 'FETCH_ORDER_SERVICES_SUGGESTIONS',
  FETCH_ORDER_SERVICES_SUGGESTIONS_SUCCESS: 'FETCH_ORDER_SERVICES_SUGGESTIONS_SUCCESS',
  FETCH_ORDER_SERVICES_SUGGESTIONS_FAIL: 'FETCH_ORDER_SERVICES_SUGGESTIONS_FAIL',
  RESET_ORDER_SERVICES_SUGGESTIONS: 'RESET_ORDER_SERVICES_SUGGESTIONS',

  FETCH_ORDER_SERVICES_SUBMISSION: 'FETCH_ORDER_SERVICES_SUBMISSION',
  FETCH_ORDER_SERVICES_SUBMISSION_SUCCESS: 'FETCH_ORDER_SERVICES_SUBMISSION_SUCCESS',
  FETCH_ORDER_SERVICES_SUBMISSION_FAIL: 'FETCH_ORDERS_SERVICES_SUBMISSION_FAIL',

  FETCH_ORDER_STATUS_CHANGE_SUBMISSION: 'FETCH_ORDER_STATUS_CHANGE_SUBMISSION',
  FETCH_ORDER_STATUS_CHANGE_SUBMISSION_SUCCESS: 'FETCH_ORDER_STATUS_CHANGE_SUBMISSION_SUCCESS',
  FETCH_ORDER_STATUS_CHANGE_SUBMISSION_FAIL: 'FETCH_ORDERS_STATUS_CHANGE_SUBMISSION_FAIL',

  FETCH_ORDER_NOTE_CHANGE_SUBMISSION: 'FETCH_ORDER_NOTE_CHANGE_SUBMISSION',
  FETCH_ORDER_NOTE_CHANGE_SUBMISSION_SUCCESS: 'FETCH_ORDER_NOTE_CHANGE_SUBMISSION_SUCCESS',
  FETCH_ORDER_NOTE_CHANGE_SUBMISSION_FAIL: 'FETCH_ORDERS_NOTE_CHANGE_SUBMISSION_FAIL',

  FETCH_SCHEDULE_ORDER_SUBMISSION: 'FETCH_SCHEDULE_ORDER_SUBMISSION',
  FETCH_SCHEDULE_ORDER_SUBMISSION_SUCCESS: 'FETCH_SCHEDULE_ORDER_SUBMISSION_SUCCESS',
  FETCH_SCHEDULE_ORDER_SUBMISSION_FAIL: 'FETCH_SCHEDULE_ORDERS_SUBMISSION_FAIL',

  FETCH_SCHEDULE_ORDER_REASONS: 'FETCH_SCHEDULE_ORDER_REASONS',
  FETCH_SCHEDULE_ORDER_REASONS_SUCCESS: 'FETCH_SCHEDULE_ORDER_REASONS_SUCCESS',
  FETCH_SCHEDULE_ORDER_REASONS_FAIL: 'FETCH_SCHEDULE_ORDER_REASONS_FAIL',

  FETCH_CANCEL_ORDER_REASONS: 'FETCH_CANCEL_ORDER_REASONS',
  FETCH_CANCEL_ORDER_REASONS_SUCCESS: 'FETCH_CANCEL_ORDER_REASONS_SUCCESS',
  FETCH_CANCEL_ORDER_REASONS_FAIL: 'FETCH_CANCEL_ORDER_REASONS_FAIL',
};

export default ordersActionTypes;
